import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles.css';
import axios from 'axios'
require('es6-promise').polyfill();

Vue.config.productionTip = false
Vue.prototype.$http = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
